export default __webpack_public_path__ + "static/logo-mineduc-6e749c2b3398ba121ee142306213996b.png";